class ProductModal {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('click', (e) => {
      // Open modal
      if (e.target.matches('[data-modal-trigger]')) {
        const modalId = e.target.getAttribute('data-modal-trigger');
        this.openModal(modalId);
      }

      // Close modal
      if (e.target.matches('[data-modal-close]') || e.target.closest('[data-modal-close]')) {
        const modalId =
          e.target.getAttribute('data-modal-close') ||
          e.target.closest('[data-modal-close]').getAttribute('data-modal-close');
        this.closeModal(modalId);
      }

      // Close modal when clicking overlay
      if (e.target.matches('.product-modal-overlay')) {
        this.closeModal(e.target.id);
      }
    });

    // Close modal on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const activeModal = document.querySelector('.product-modal-overlay.active');
        if (activeModal) {
          this.closeModal(activeModal.id);
        }
      }
    });

    // Handle form submissions
    document.addEventListener('submit', (e) => {
      if (e.target.matches('.product-modal-form')) {
        e.preventDefault();
        this.addToCart(e.target);
      }
    });
  }

  openModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.add('active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }

  closeModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.querySelectorAll('.collapsible-trigger.is-open').forEach(trigger => {
        trigger.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        const contentId = trigger.getAttribute('aria-controls');
        const content = contentId ? document.getElementById(contentId) : null;
        if (content) {
          content.classList.remove('is-open');
          content.style.height = '0px';
        }
      });
      modal.classList.remove('active');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  async addToCart(form) {
    const formData = new FormData(form);
    const button = form.querySelector('.product-modal-add-to-cart');
    const originalText = button.textContent;

    button.textContent = 'Adding...';
    button.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        button.textContent = 'Added!';

        // Dispatch custom event for cart updates
        window.dispatchEvent(new CustomEvent('cart:updated'));

        // Reset button after 2 seconds
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      button.textContent = 'Error - Try again';
      button.disabled = false;
    }
  }
}

// Initialize modal functionality
if (typeof window.productModal === 'undefined') {
  window.productModal = new ProductModal();
}
